<app-floorplan-item-details
  i18n-title="@@floorplan.details.referenceMeasure.header"
  title="Referenzmaß"
  [floorplanItem]="referenceMeasure"
  [duplicateEnabled]="false"
>
  <div data-main>
    <form odxForm [formGroup]="referenceMeasureForm" [disabled]="referenceMeasure.locked">
      <odx-form-field i18n-label="@@floorplan.details.referenceMeasure.form.text.label" label="Maßstab (in Meter)">
        <input
          formControlName="text"
          odxFormFieldControl
          i18n-placeholder="@@floorplan.details.referenceMeasure.form.text.placeholder"
          placeholder="Maßstab"
          (blur)="onTextBlur()"
        />
        <ng-template odxFormFieldError="pattern">
          <ng-container i18n="@@floorplan.details.referenceMeasure.errorMessage.numbersOnly"
            >Bitte nur Zahlenwerte eintragen</ng-container
          >
        </ng-template>
      </odx-form-field>
    </form>
  </div>
</app-floorplan-item-details>
